
<ng-container *ngIf="isLoaded">
  <div class="modal-close-btn" (click)="closeModal()">X</div>
  <div class="card mb-3">
    <div class="card-body">
      <div class="pt-4 pb-2">
        <h5 class="card-title text-center pb-0 fs-4">Редакция на Документ</h5>
        <p class="text-center small">Моля, направете нужните промени</p>
      </div>

      <form [formGroup]="Form" class="row g-3 needs-validation" (ngSubmit)="onSubmit()">
        <div class="col-12">
          <label for="title" class="form-label">Име</label>
          <input type="text" formControlName="title" class="form-control" id="title">
        </div>
        <div class="col-12">
          <label for="description" class="form-label">Кратко Описание</label>
          <input type="text" formControlName="description" class="form-control" id="description">
        </div>
        <div class="col-12">
          <label for="documentTypes" class="form-label">Тип на Документа</label>
          <select formControlName="documentTypes" class="form-select">
            <option value="" disabled>Изберете Тип на Документа</option>
            <option *ngFor="let docType of documentTypes" [value]="docType.idDocumentType">{{ docType.title.replace('_',' ') }}</option>
          </select>
        </div>
        <div class="col-12">
          <label for="signedType" class="form-label">Тип</label>
          <select formControlName="signedType" class="form-select">
            <option value="" disabled>Изберете вид Подпис</option>
            <option *ngFor="let signType of signingTypes" [value]="SigningType[signType]">{{ signType.replace('_',' ') }}</option>
          </select>
        </div>
        <div class="col-12">
          <div class="form-check">
            <input class="form-check-input" type="checkbox" formControlName="isGlobal" id="isGlobal">
            <label class="form-check-label" for="isGlobal">Глобална</label>
          </div>
        </div>

        <div class="col-12">
          <div class="form-check">
            <input class="form-check-input" type="checkbox" formControlName="isActive" id="isActive">
            <label class="form-check-label" for="isActive">Активна</label>
          </div>
        </div>
        <div class="col-12">
          <button class="btn btn-primary w-100" type="submit" [disabled]="!Form.valid">Промени</button>
        </div>
      </form>
    </div>
  </div>

</ng-container>
